import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './components/Login/AuthContext';
import App from './App';
import LandingPage from './components/Page/LandingPage';
import TermsOfService from './components/Page/TermsOfService';
import PrivacyPolicy from './components/Page/PrivacyPolicy';
import PricingPage from './components/Page/PricingPage';
import Login from './components/Login/Login';
import Signup from './components/Login/Signup';
import LoginWithToken from './components/Login/LoginWithToken';
import ScrollToTop from './components/UI/ScrollToTop';
import PhotoManager from './components/App/PhotoManager';
import StylesManager from './components/StyleAdmin/StylesManager';

// Import styles if needed
import './App.css';

const AppRouter = () => {
    const { isAuthenticated } = useContext(AuthContext);

    return (
        <Router>
            <ScrollToTop />
            <Routes>
                {/* Public routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/admin/styles" element={<StylesManager />} />
                
                {/* Auth routes with redirects */}
                <Route
                    path="/login"
                    element={isAuthenticated ? <Navigate to="/app" /> : <Login />}
                />
                <Route
                    path="/signup"
                    element={isAuthenticated ? <Navigate to="/app" /> : <Signup />}
                />
                <Route
                    path="/login_with_token"
                    element={isAuthenticated ? <Navigate to="/app" /> : <LoginWithToken />}
                />
                             
                {/* App routes - all nested within App component */}
                <Route
                    path="/app/*"
                    element={isAuthenticated ? <App /> : <Navigate to="/login" />}
                />
                
                {/* Fallback route */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
};

export default AppRouter; 